import React from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
import SlideUpPanel from '../../../../slide-up-panel/slide-up-panel.js';
import './wizard-slide-up-panel.css';
function WizardSlideUpPanel(props) {
    const className = classNames({
        'c-wizard-slide-up-panel': true,
        'c-wizard-slide-up-panel--with-groups': props.groupsPropsMap.size > 0,
    });
    return (React.createElement(SlideUpPanel, { className: className, closeable: true, onClose: props.onClose, open: props.open },
        React.createElement(SlideUpPanel.Content, null, props.children)));
}
export { WizardSlideUpPanel, };
//# sourceMappingURL=wizard-slide-up-panel.js.map